import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
    ProSkillManagerAssessmentStatusType
} from "~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentStatusType";
import {
    ProSkillManagerCandidateStatusType
} from "~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateStatusType";

export class ProSkillAssureMyAssessmentModel extends Model {
    constructor(
        public id: number = 0,
        public title: string = "",
        public questionCount: number = 0,
        public totalTime: number = 0,
        public isNoTimeLimit: boolean = false,
        public startedAt: string = "",
        public endedAt: string = "",
        public assessmentStatus: ProSkillManagerAssessmentStatusType = ProSkillManagerAssessmentStatusType.ENDED,
        public processStatus: ProSkillManagerCandidateStatusType = ProSkillManagerCandidateStatusType.COMPLETED,
        public candidateStats: CandidateStats = new CandidateStats()
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureMyAssessmentModel>): ProSkillAssureMyAssessmentModel {
        return createModel<ProSkillAssureMyAssessmentModel>(ProSkillAssureMyAssessmentModel, {
            ...model
        });
    }
}

class CandidateStats {
    constructor(
      public preStart: number = 0,
      public started: number = 0,
      public completed: number = 0
    ) {
    }
}
